import React from 'react';
import { Typography, Box } from '@mui/material';
import CommonModal from 'pages/ShareYourLight/components/CommonModal';
import SYLButton from 'pages/ShareYourLight/components/SYLButton';

interface ConfirmCloseModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

function ConfirmCloseModal({ open, onCancel, onConfirm }: ConfirmCloseModalProps) {
  return (
    <CommonModal
      open={open}
      onClose={onCancel}
      paperSx={{ maxWidth: 400 }}
      title={(
        <Typography variant='h6' color='#FED892' fontWeight={400} textAlign='center'>
          Discard your message?
        </Typography>
      )}
    >
      <Box display='flex' flexDirection='column' alignItems='center' gap={3}>
        <Typography color='#DADADA' fontSize={16} textAlign='center'>
          If you close now, your message will not be saved.
        </Typography>
        <Box display='flex' gap={2} width='100%' justifyContent='center'>
          <SYLButton variant='outlined' onClick={onConfirm} sx={{ minWidth: 100 }}>
            Discard
          </SYLButton>
          <SYLButton variant='contained' onClick={onCancel} sx={{ minWidth: 100 }}>
            Continue Editing
          </SYLButton>
        </Box>
      </Box>
    </CommonModal>
  );
}

export default ConfirmCloseModal;
